import { Button, Dialog } from "@app/ui";
import { useI18n } from "../../lib/useI18n.js";
import { useRollupConfirmStore } from "../../stores/index.js";

/** Popup for the "ask each time" subtask roll-up mode. Asks whether a completion
 *  should also apply to the related tasks (children when completing a parent;
 *  parent when completing the last child). */
export function RollupConfirmDialog() {
  const { t } = useI18n();
  const { open, pending, resolve } = useRollupConfirmStore();
  if (!pending) return null;

  const verb = pending.done ? t("rollup.complete") : t("rollup.reopen");
  const what = pending.done ? t("rollup.completed") : t("rollup.reopened");
  const noun = pending.task.is_event ? t("common.event") : t("common.task");
  const cascadeLabel =
    pending.direction === "down"
      ? t("rollup.cascadeDown", { verb })
      : t("rollup.cascadeUp", { verb });
  const onlyLabel = t("rollup.onlyThis", { noun });

  return (
    <Dialog open={open} onClose={() => resolve("cancel")} title={t("rollup.title", { verb })} className="max-w-md">
      <div className="flex flex-col gap-4">
        <p className="text-sm text-foreground">
          {t("rollup.body", { title: pending.task.title || t("agenda.untitled"), what })}
        </p>
        <div className="flex flex-col gap-2">
          <Button variant="primary" onClick={() => resolve("cascade")}>{cascadeLabel}</Button>
          <Button variant="outline" onClick={() => resolve("only")}>{onlyLabel}</Button>
          <Button variant="ghost" onClick={() => resolve("cancel")}>{t("common.cancel")}</Button>
        </div>
      </div>
    </Dialog>
  );
}
